import { render } from "./BookingHours.vue?vue&type=template&id=65579d65&scoped=true"
import script from "./BookingHours.vue?vue&type=script&lang=js"
export * from "./BookingHours.vue?vue&type=script&lang=js"

import "./BookingHours.vue?vue&type=style&index=0&id=65579d65&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65579d65"]])

export default __exports__